import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pair-devices__loading" }
const _hoisted_2 = { class: "pair-devices__amount" }
const _hoisted_3 = { class: "pair-devices__list" }

import { ref, computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { NModal, NSelect } from 'naive-ui'
import { SelectMixedOption } from 'naive-ui/es/select/src/interface'
import {
  antDevice,
  bleDevice,
  deviceType,
  deviceProtocol,
} from '@/types/device'
import { MqttTopic } from '@/mqttDefinitions/topics'

//Store
import { useMqttStore } from '@/store/mqttStore'
import { useDeviceStore } from '@/store/deviceStore'
import { storeToRefs } from 'pinia'
import { BfButton, BfLoader, ButtonState } from '@finetic/bikefitting-ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'PairDevices',
  props: {
    type: { default: deviceType.heartRate }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit
const mqttStore = useMqttStore()
const deviceStore = useDeviceStore()

const showModal = computed({
  get() {
    return true
  },
  set() {
    cancel()
    return false
  },
})

const { doSubscribe, doUnSubscribe, doRawPublish, client } = mqttStore
const { getAntDevicesByType, getBleDevicesByType } = storeToRefs(deviceStore)
const { t } = useI18n()

const antDevices = computed(() => getAntDevicesByType.value(props.type))
const bleDevices = computed(() => getBleDevicesByType.value(props.type))

const { updateAntList, updateBleList } = deviceStore

const antDevicesTopic = MqttTopic.DEVICES_ANT_LIST
const bleDevicesTopic = MqttTopic.DEVICES_BLE_LIST

const { getRawValueOnTopic } = storeToRefs(mqttStore)

doSubscribe(antDevicesTopic, client)
doSubscribe(bleDevicesTopic, client)

const antDevicesList = computed(() => getRawValueOnTopic.value(antDevicesTopic))
const bleDevicesList = computed(() => getRawValueOnTopic.value(bleDevicesTopic))

watch([antDevicesList, bleDevicesList], () => {
  updateAntList(antDevicesList.value as Array<antDevice>)
  updateBleList(bleDevicesList.value as Array<bleDevice>)

  const ant = antDevices.value
  const ble = bleDevices.value

  if (ant.length > 0) {
    selectedDevice.value = `ANT|${ant[0].id}`
  } else if (ble.length > 0) {
    selectedDevice.value = `BLE|${ble[0].id}`
  } else {
    selectedDevice.value = 0
  }
})

const selectedDevice = ref()

const devicesOptions = computed(() => {
  if (antDevices.value.length > 0 || bleDevices.value.length > 0) {
    const options = new Array<SelectMixedOption>()

    options.push({
      label: t('devices.pair.selectDevice'),
      value: 0,
      disabled: true,
    })

    antDevices.value.forEach((device: any) => {
      const option = {
        label: `${device.name} (${device.id})`,
        value: `ANT|${device.id}`,
      }

      options.push(option)
    })

    bleDevices.value.forEach((device: any) => {
      const option = {
        label: `${device.name} (${device.id})`,
        value: `BLE|${device.id}`,
      }

      options.push(option)
    })

    return options
  } else {
    return [
      {
        label: t('devices.pair.noDevicesFound'),
        value: 0,
        disabled: true,
      },
    ]
  }
})

const deviceConnectTopic = (protocol: deviceProtocol) => {
  switch (protocol.toUpperCase()) {
    case deviceProtocol.ANT:
      return MqttTopic.DEVICES_ANT_CONNECT
    case deviceProtocol.BLE:
      return MqttTopic.DEVICES_BLE_CONNECT
    default:
      return undefined
  }
}

const save = () => {
  const [protocol, id] = selectedDevice.value.split('|')

  let newDevice: antDevice | bleDevice | undefined = undefined
  const topic = deviceConnectTopic(protocol)

  switch (protocol.toUpperCase()) {
    case deviceProtocol.ANT:
      newDevice = antDevices.value.find((x) => x.id == id)
      break

    case deviceProtocol.BLE:
      newDevice = bleDevices.value.find((x) => x.id == id)
      break
  }

  if (newDevice && topic) {
    const payload = JSON.stringify({
      name: newDevice['name'],
      id: newDevice['id'],
      type: newDevice['type'],
    })

    doRawPublish(topic, payload, client).then(() => {
      emit('close')
    })
  }
}

const cancel = () => {
  doUnSubscribe(antDevicesTopic, client)
  doUnSubscribe(bleDevicesTopic, client)

  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NModal), {
    show: showModal.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
    style: {"width":"600px"},
    class: "custom-card",
    preset: "card",
    title: _unref(t)('devices.pair.title'),
    bordered: false,
    size: "huge"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(BfLoader)),
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_unref(t)('devices.pair.searching', { type: _unref(t)(`devices.types.${__props.type}`) })) + " ", 1),
          _createElementVNode("span", _hoisted_2, " (" + _toDisplayString(_unref(t)('devices.pair.devicesFound', {
              count: antDevices.value.length + bleDevices.value.length,
            })) + ") ", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(NSelect), {
          value: selectedDevice.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedDevice).value = $event)),
          disabled: antDevices.value.length == 0 && bleDevices.value.length == 0,
          options: devicesOptions.value
        }, null, 8, ["value", "disabled", "options"]),
        _createVNode(_unref(BfButton), {
          state: selectedDevice.value ? _unref(ButtonState).Enabled : _unref(ButtonState).Disabled,
          onClick: save
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.select')), 1)
          ]),
          _: 1
        }, 8, ["state"])
      ])
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})